// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-3876n","header":"header-3gUb3","body":"body-1fH02","footer":"footer-7Y2QV","title":"title-2CGpm"};